export enum WalletRefundsRoutesEnum {
  WALLET_REFUNDS_LIST = 'wallet-refunds-list',
  WALLET_REFUND_DETAIL = 'wallet-refund-detail',
}
